import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import useSearchShipments from '@afosto/queries/fulfilment/useSearchShipments';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const ShipmentsFormatter = ({ shipmentIds }) => {
  const { data: shipments, isLoading } = useSearchShipments(
    {
      constraints: [
        {
          key: 'ids',
          operator: 'in',
          value: [...new Set(shipmentIds)],
        },
      ],
    },
    { enabled: shipmentIds?.length > 0 },
  );

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return shipments?.length > 0
    ? shipments.map((shipment, idx) => (
        <Fragment key={shipment.id}>
          <MuiLink variant="subtitle1" component={Link} to={`/shipments/${shipment.id}`}>
            {shipment.number ?? 'Concept'}
          </MuiLink>
          {shipments.length !== idx + 1 && ', '}
        </Fragment>
      ))
    : '-';
};

ShipmentsFormatter.propTypes = {
  shipmentIds: PropTypes.array,
};

ShipmentsFormatter.defaultProps = {
  shipmentIds: [],
};

export default ShipmentsFormatter;
